import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { validatePermission } from 'actions';
import ApplicationLayout from 'v3/layouts/Application';
import Space from 'v3/components/Space';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import { useProduct } from '../shared/context';
import Data from './Data';

export default function ProductDetails() {
  const navigate = useNavigate();
  const product = useProduct();
  const [hasPermissionToEdit, setPermissionToEdit] = useState(true);

  function handleCreateNewProduct() {
    product.setData({
      id: null,
      name: null,
      productNcm: null,
      unit_measure: null,
      points: null,
      productType: null,
      ncm: null,
    });
    product.setErrors({});
    navigate('/produtos/cadastrar');
  }

  useEffect(() => {
    function validateProductPermission() {
      setPermissionToEdit(validatePermission('ALTERAR_PRODUTOS'));
    }
    validateProductPermission();
  }, []);

  useEffect(() => {
    if (!hasPermissionToEdit) {
      product.showSnackbar('Você não tem permissão para editar produto', {
        type: 'error',
      });
      navigate('/');
    }
  }, [hasPermissionToEdit]);

  return (
    <ApplicationLayout
      title="Produtos"
      RightComponent={
        <Space x="8px">
          <Button variant="secondary" onClick={() => navigate(-1)}>
            <Text type="regular" color="dark" weight="semiBold">
              Voltar
            </Text>
          </Button>
          <Button onClick={handleCreateNewProduct}>
              <Text type="regular" color="white" weight="semiBold">
                Novo produto
              </Text>
            </Button>
        </Space>
      }
    >
      <Row>
        <Col md={6} xs={12}>
          <Data />
        </Col>
      </Row>
    </ApplicationLayout>
  );
}
